import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <path
    d="M12 6.50696C5.439 6.50696 2 11.248 2 12C2 12.752 5.439 17.493 12 17.493C18.56 17.493 22 12.752 22 12C22 11.248 18.56 6.50696 12 6.50696ZM12 16.225C9.545 16.225 7.555 14.334 7.555 12C7.555 9.66596 9.545 7.77496 12 7.77496C14.455 7.77496 16.445 9.66596 16.445 12C16.445 14.334 14.455 16.225 12 16.225ZM12 12C11.593 11.562 12.663 9.88696 12 9.88696C10.772 9.88696 9.778 10.833 9.778 12C9.778 13.167 10.773 14.113 12 14.113C13.227 14.113 14.222 13.167 14.222 12C14.222 11.464 12.346 12.372 12 12Z"
    fill="currentColor"
  />
);

const Icon = createSvgIcon(svg, 'EyeFill');

export default Icon;
